export const environment = {
  properties: {
    analytics: {
      tagManagerContainerId: 'GTM-PZNCSJK',
    },
    app: {
      environmentLabel: '',
      featureFlags: {},
      externalUrls: {
        serviceDeskLink: 'https://www.it.psu.edu/support',
      },
    },
    cdn: {
      baseUrl: 'https://static.apps.psu.edu/',
    },
    fortress: {
      activatedRoles: [],
      url: 'https://develop-fortress-service.qa.k8s.psu.edu/fortress-service-web/resources/',
    },
    ssrm: {
      url: 'https://develop-ssrm-service.qa.k8s.psu.edu/resources/',
    },
    oauth: {
      clientId: '8bae6286-7707-4444-84ce-69b387cb89bc',
      discoveryDocumentUrl: 'https://develop-hydra-auth-server.qa.k8s.psu.edu/.well-known/openid-configuration',
      issuer: 'https://develop-oauth2-server.qa.k8s.psu.edu/',
      preserveRequestedRoute: true,
      redirectUri: 'https://ssrm.development.apps.psu.edu',
      responseType: 'code',
      scope: 'openid offline_access',
      showDebugInformation: true,
      strictDiscoveryDocumentValidation: false,
    },
  },
};
